<mat-progress-bar mode="determinate" [value]="value" style="--pbfillcolor: var(--{{fillColor}})"></mat-progress-bar>